import { ReactNode } from "react";
import styled from "styled-components";
import { minMedium } from "@songtradr-one/components-frontend";
import {
  HashedDynamicPermission,
  HashedPermission,
} from "@songtradr-one/shared-common";
import { Page } from "../page/Page.Parts";

// TEXT

// STYLES
export const TabbedPageContainer = styled(Page)`
  --tabbed-shell-gap: 3rem;

  flex-grow: 1;
  gap: var(--tabbed-shell-gap);
  padding: 1.25rem 0 3rem;

  @media ${minMedium} {
    padding: 3rem 0;
  }
`;

export const Collapsible = styled.div<{ $hidden?: boolean }>`
  display: grid;
  grid-template-rows: ${({ $hidden }) => ($hidden ? "0fr" : "1fr")};
  margin-bottom: ${({ $hidden }) =>
    $hidden ? "calc(-1 * var(--tabbed-shell-gap))" : "0"};

  @media (prefers-reduced-motion: no-preference) {
    transition:
      grid-template-rows 0.3s ease-in-out,
      margin-bottom 0.3s ease-in-out;
  }
`;

export const CollapsibleInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--tabbed-shell-gap);
  overflow: hidden;
  min-height: 0;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  gap: 1rem;

  @media ${minMedium} {
    gap: 1.5rem;
  }
`;

export const HeadingWrapper = styled.div<{ maxWidth?: string }>`
  max-width: ${({ maxWidth }) => maxWidth || "46rem"};
`;

// DATA

// TYPES
export interface TabbedShellElement {
  label: string;
  route: string;
  slug?: string;
  permissions?: (HashedPermission | HashedDynamicPermission)[];
  permissionMatchAll?: boolean;
}

export interface Props {
  pageTitle: string;
  pageTitleMaxWidth?: string;
  tabs: TabbedShellElement[];
  className?: string;
  buttons?: ReactNode;
  tabActions?: ReactNode;
  outletContext?: unknown;
  back?: string;
  hideCollapsible?: boolean;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
